module.exports = __webpack_public_path__ + "img/5.6a4236cd.svg";